export default __webpack_public_path__ + "static/media/mibcity.a86901a8.png";